// extracted by mini-css-extract-plugin
module.exports = {"label":"az_XLb","value":"az_YLb","labelContainer":"az_ZLb"};